import { useEffect, useId, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../Button';
import { Close, Search } from '../Icons';

interface Props {
    classNames?: string;
    onSearch: (value: string) => void;
}

export const SearchInput = ({ classNames, onSearch }: Props) => {
    const { t } = useTranslation();
    const [search, setSearch] = useState<string>('');
    const inputId = useId();

    useEffect(() => {
        const handle = setTimeout(() => {
            onSearch(search);
        }, 500);

        return () => {
            clearTimeout(handle);
        };
    }, [search]);

    return (
        <div className={`bg-white border-2 border-gray-500 rounded-webinarsub flex ${classNames}`}>
            <span className="flex-none self-center py-3 pl-3">
                <Search classNames="size-6 stroke-current opacity-75" />
            </span>
            <label htmlFor={inputId} className="sr-only">
                {t('Search.Placeholder')}
            </label>
            <input
                id={inputId}
                type="text"
                autoCorrect="off"
                spellCheck="false"
                autoComplete="off"
                placeholder={t('Search.Placeholder')}
                className="w-full bg-transparent border-none px-4 placeholder:text-input-placeholder"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
            ></input>
            {search.length > 0 && (
                <Button iconbtn aria-label={t('Search.Button.Clear.AriaLabel')} onClick={() => setSearch('')}>
                    <Close classNames="size-6 stroke-current" />
                </Button>
            )}
        </div>
    );
};
